import type { RootState } from '@reducers/index';
import { updateOrder as updateListingOrder } from '@reducers/search';
import { SearchOrders } from '@sbt-web/network/types';
import { SelectBox, type SelectOption } from '@sbt-web/ui';
import { ordersFullLabelsMap } from '@tools/search/values';
import { getOrCreatePulse } from '@tools/tracking/utils';
import React from 'react';
import { connect } from 'react-redux';

import ownClasses from './index.module.scss';

interface StateProps {
  orders: SearchOrders[];
  orderIndex: number;
}

interface DispatchProps {
  updateOrder: (order: SearchOrders) => void;
}

type Props = StateProps & DispatchProps;

const OrderComponent: React.FunctionComponent<Props> = (props) => {
  const list = props.orders.map((order) => ({
    name: ordersFullLabelsMap[order],
    value: order,
  }));

  const handleSelection = (options: SelectOption[]) => {
    getOrCreatePulse()?.queueEvent({
      type: 'Click',
      object: {
        type: 'UIElement',
        '@id': 'sdrn:subito:listing:search:element:filters-button',
        name: 'Sorting Filters Button',
        elementType: 'Button',
        label: `${options[0]?.value}`,
      },
    });

    return props.updateOrder(options[0].value as SearchOrders);
  };

  return (
    <SelectBox
      name="sort"
      classes={['order-selector', ownClasses['order-selector']]}
      flavor="small"
      selectedIndices={[props.orderIndex]}
      valueList={list}
      onSelect={handleSelection}
    />
  );
};

export const OrderSelector = connect<
  StateProps,
  DispatchProps,
  unknown,
  RootState
>(
  (state: RootState) => ({
    orders: state.search.category.orders,
    orderIndex: state.search.orderIndex,
  }),
  (dispatch) => ({
    updateOrder: (order: SearchOrders) => dispatch(updateListingOrder(order)),
  })
)(OrderComponent);

export { OrderComponent };
